export const DISPUTED_MATCH_LIST_UPDATE = 'DISPUTED_MATCH_LIST_UPDATE';

export const disputeListUpdated = (matches) => {
	return {
		type: DISPUTED_MATCH_LIST_UPDATE,
		payload: matches,
	};
};